
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { API_ROUTES } from "@/utils/API";
import { WARNING_POPUP_TYPE } from "@/constants/popupTypes";
import { API_TSubscriptionDetails } from "@/models/company_subscription";
import {
  SUBSCRIPTION_STATUSES,
  COMPLIANCE_PACKAGES,
  SUBSCRIPTION_STATUS_ACTIVE,
} from "@/constants/subscription";
import { formatDateToString } from "@/utils/dates";

const NULL_DATE = "01/01/0001";

@Component
export default class ManageSubscriptionPopup extends Vue {
  @Prop({ type: Boolean, default: false }) readonly show!: boolean;
  @Prop({ type: String, default: WARNING_POPUP_TYPE }) readonly type!: string;

  subscriptionStatuses = SUBSCRIPTION_STATUSES;

  compliancePackages = COMPLIANCE_PACKAGES;

  showPopup = false;

  @Watch("show", { immediate: true })
  showPopupChanged(val: boolean) {
    this.showPopup = val;
  }

  open() {
    this.showPopup = true;
  }

  close() {
    this.showPopup = false;

    this.$emit("close");
  }

  form: API_TSubscriptionDetails = {
    compliance_package: "",
    subscription_end_date: "",
    subscription_start_date: "",
    subscription_status: "",
    trial_end_date: "",
    trial_start_date: "",
  };

  loading = false;

  get companyId(): number {
    return Number(this.$route.params.company_id ?? 0);
  }

  setFormData(data: API_TSubscriptionDetails) {
    this.form = data;

    if (data.subscription_start_date === NULL_DATE) data.subscription_start_date = this.today;
    if (data.subscription_end_date === NULL_DATE) data.subscription_end_date = this.oneYearFromNow;
    if (data.trial_start_date === NULL_DATE) data.trial_start_date = this.today;
    if (data.trial_end_date === NULL_DATE) data.trial_end_date = this.oneMonthFromNow;
  }

  async fetchSubscriptionDetails() {
    if (!this.companyId) return;

    try {
      const { data } = await this.axios.get(
        API_ROUTES.EXPERT_COMPANY_SUBSCRIPTION_STATUS(this.companyId)
      );

      if (!data) return;

      this.setFormData(data);
    } finally {
      this.loading = false;
    }
  }

  async saveSubscriptionDetails() {
    if (!this.companyId) return;

    try {
      await this.axios.put(
        API_ROUTES.EXPERT_COMPANY_SUBSCRIPTION_STATUS(this.companyId),
        this.form
      );

      this.close();
    } finally {
      this.loading = false;
    }
  }

  async mounted() {
    await this.fetchSubscriptionDetails();
  }

  get today() {
    const currentDate = new Date();

    return formatDateToString(currentDate);
  }

  get oneYearFromNow() {
    const currentDate = new Date();

    currentDate.setFullYear(currentDate.getFullYear() + 1);

    return formatDateToString(currentDate);
  }

  get oneMonthFromNow() {
    const currentDate = new Date();

    currentDate.setMonth(currentDate.getMonth() + 1);

    return formatDateToString(currentDate);
  }

  get isDisabled() {
    if (this.form.subscription_status === SUBSCRIPTION_STATUS_ACTIVE)
      return this.form.compliance_package?.length === 1;

    return false;
  }
}
